import React, { useContext } from 'react';
import Button from '@material-ui/core/Button';
import { STRING_TRUE, STRING_FALSE } from '@mummssoftware/utils/constants';
import { FajitaContext } from './Context';
import { SHOW_STICKIES } from './Context/constants';
import {
  SubmitPlanDiv,
  StickyDialogDiv,
} from '../../components/layout/WrapperDiv';
import defaults from '../../translations/en.json';

export const StickyDialog = () => {
  const { dispatch } = useContext(FajitaContext);

  const onDiscardSticky = async () => {
    dispatch({
      type: SHOW_STICKIES,
      payload: STRING_FALSE,
    });
  };

  const onShowSticky = () => {
    dispatch({
      type: SHOW_STICKIES,
      payload: STRING_TRUE,
    });
  };

  return (
    <StickyDialogDiv>
      {defaults.showStickies}
      <SubmitPlanDiv>
        <Button
          type="submit"
          variant="contained"
          size="small"
          onClick={() => onDiscardSticky()}
          color="primary"
        >
          {defaults.no}
        </Button>
        <Button
          type="submit"
          variant="contained"
          size="small"
          onClick={() => onShowSticky()}
          color="primary"
        >
          {defaults.yes}
        </Button>
      </SubmitPlanDiv>
    </StickyDialogDiv>
  );
};
